<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h1 class="Poem-title" id="_idParaDest-1" lang="en-GB"><a id="_idTextAnchor001"></a>Greed</h1>
<p class="Verse-first" lang="en-GB">Two phones</p>
<p class="Verse-main" lang="en-GB">Two girls</p>
<p class="Verse-main" lang="en-GB">Two presents</p>
<p class="Verse-main" lang="en-GB">Too much fun.</p>
<p class="Verse-new" lang="en-GB">Two presents</p>
<p class="Verse-main" lang="en-GB">Less money</p>
<p class="Verse-main" lang="en-GB">Two people to be funny</p>
<p class="Verse-main" lang="en-GB">Two schedules</p>
<p class="Verse-main" lang="en-GB">Two days less to myself.</p>
<p class="Verse-new" lang="en-GB">Two girls, two dates</p>
<p class="Verse-main" lang="en-GB">To lighten my ego</p>
<p class="Verse-main" lang="en-GB">But, two days when I want to laze</p>
<p class="Verse-main" lang="en-GB">I have a headache.</p>
<p class="Verse-new" lang="en-GB">Two girls,</p>
<p class="Verse-main" lang="en-GB">One I like better.</p>
<p class="Verse-main" lang="en-GB">Two cries</p>
<p class="Verse-main" lang="en-GB">One is bitter.</p>
<p class="Verse-main" lang="en-GB">Two girls,</p>
<p class="Verse-main" lang="en-GB">Now I have to run.</p>
<p class="Verse-main" lang="en-GB">I’m now not thinking</p>
<p class="Verse-main" lang="en-GB">This is not so much fun.</p>
<p class="Verse-new" lang="en-GB">Two girls, two fights</p>
<p class="Verse-main" lang="en-GB">I’m now taking fright.</p>
<p class="Verse-main" lang="en-GB">I think one girl will do,</p>
<p class="Verse-main" lang="en-GB">One phone, no headache.</p>
<p class="Verse-main" lang="en-GB">My bank balance looks much better,</p>
<p class="Verse-main" lang="en-GB">I’m now less of a fretter.</p>
<p class="Verse-first" lang="en-GB">One girl</p>
<p class="Verse-main" lang="en-GB">One dial</p>
<p class="Verse-main" lang="en-GB">One home</p>
<p class="Verse-main" lang="en-GB">And one love.</p>
<p class="Verse-main" lang="en-GB">Thanks, I’ll take note from above.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781398432048_EPUB5.vue?326209e6